import { auth } from '@monorepo/utils/firebase'
import { log } from '@monorepo/utils/utils'
import { createUserWithEmailAndPassword as createUserWithEmailAndPasswordFirebase } from '@monorepo/utils/firebase'

export const createUserWithEmailAndPassword = async (payload: { email: string; password: string }) => {
  // Check if the current user is anonymous
  const currentUser = auth().currentUser

  if (currentUser && currentUser.isAnonymous) {
    // For anonymous users with email registration, we need to create a new account
    // and then migrate data from the anonymous account
    try {
      // Store the anonymous user ID for migration
      const anonymousUserId = currentUser.uid

      // Create the new email/password account
      const newUserCredential = await createUserWithEmailAndPasswordFirebase(auth(), payload.email, payload.password)

      // Migrate data from anonymous account to new account
      // This uses the same migration logic as handleAuthWithCredential
      try {
        const { authFetch } = await import('@monorepo/utils/auth-fetch')
        const { createUrl, POST } = await import('@monorepo/utils/api')

        await authFetch(createUrl(POST.USER.MIGRATE), {
          body: JSON.stringify({
            from: anonymousUserId,
            to: newUserCredential.user.uid,
          }),
        })
        log(`Data migrated from anonymous user ${anonymousUserId} to ${newUserCredential.user.uid}`)
      } catch (migrationError) {
        console.error('Error during data migration:', migrationError)
        // Don't throw here, we still want to complete the registration
      }

      return {
        user: newUserCredential.user,
        provider: 'email',
      }
    } catch (error) {
      console.error('Error creating email account for anonymous user:', error)
      throw error
    }
  } else {
    // Normal flow - create a new user
    const user = await createUserWithEmailAndPasswordFirebase(auth(), payload.email, payload.password)
    return {
      user,
      provider: 'email',
    }
  }
}
